import React from 'react';
import SalesDashboard from './sales/SalesDashboard';
import OEMSalesDashboard from './sales/OEMSalesDashboard';
import AftermarketSalesDashboard from './sales/AftermarketSalesDashboard';
import MarketingDashboard from './marketing/MarketingDashboard';
import AfterSalesDashboard from './aftersales/AfterSalesDashboard';
import WarrantyClaimsDashboard from './aftersales/WarrantyClaimsDashboard';
import AMCContractsDashboard from './aftersales/AMCContractsDashboard';
import SparePartsInventoryDashboard from './aftersales/SparePartsInventoryDashboard';
import TechnicianPerformanceDashboard from './aftersales/TechnicianPerformanceDashboard';
import PredictiveMaintenanceDashboard from './aftersales/PredictiveMaintenanceDashboard';
import RootCauseAnalysisDashboard from './aftersales/RootCauseAnalysisDashboard';
import FinanceDashboard from './finance/FinanceDashboard';
import ExecutiveSummaryDashboard from './executive/ExecutiveSummaryDashboard';
import PlaceholderPage from './PlaceholderPage';
import ProductLinePerformanceDashboard from './sales/ProductLinePerformanceDashboard';
import RegionalSalesDashboard from './sales/RegionalSalesDashboard';
import CustomerProfitabilityDashboard from './sales/CustomerProfitabilityDashboard';
import SalesForecastingDashboard from './sales/SalesForecastingDashboard';
import OrderBookVsDeliveriesDashboard from './sales/OrderBookVsDeliveriesDashboard';
import NewBusinessPipelineDashboard from './sales/NewBusinessPipelineDashboard';
import CampaignPerformanceDashboard from './marketing/CampaignPerformanceDashboard';
import DigitalAnalyticsDashboard from './marketing/DigitalAnalyticsDashboard';
import ProductLaunchTrackerDashboard from './marketing/ProductLaunchTrackerDashboard';
import DealerPerformanceDashboard from './marketing/DealerPerformanceDashboard';
import MarketShareAnalysisDashboard from './marketing/MarketShareAnalysisDashboard';
import ChannelROIAnalysisDashboard from './marketing/ChannelROIAnalysisDashboard';
import ManufacturingOverviewDashboard from './manufacturing/ManufacturingOverviewDashboard';
import ProductionOutputDashboard from './manufacturing/ProductionOutputDashboard';
import CapacityUtilizationDashboard from './manufacturing/CapacityUtilizationDashboard';
import AuditOverviewDashboard from './audits/AuditOverviewDashboard';
import InternalAuditsDashboard from './audits/InternalAuditsDashboard';
import ExternalOEMAuditsDashboard from './audits/ExternalOEMAuditsDashboard';
import PLByBusinessLineDashboard from './finance/PLByBusinessLineDashboard';
import CostAnalyticsDashboard from './finance/CostAnalyticsDashboard';
import WorkingCapitalDashboard from './finance/WorkingCapitalDashboard';
import CapexTrackingDashboard from './finance/CapexTrackingDashboard';
import PlantCostComparisonDashboard from './finance/PlantCostComparisonDashboard';
import ScenarioModellingDashboard from './finance/ScenarioModellingDashboard';
import SupplyChainOverviewDashboard from './supplychain/SupplyChainOverviewDashboard';
import VendorPerformanceDashboard from './supplychain/VendorPerformanceDashboard';
import ProcurementCostTrendsDashboard from './supplychain/ProcurementCostTrendsDashboard';
import LeadTimeLogisticsDashboard from './supplychain/LeadTimeLogisticsDashboard';
import MaterialRiskAlertsDashboard from './supplychain/MaterialRiskAlertsDashboard';
import ImportExportTrackerDashboard from './supplychain/ImportExportTrackerDashboard';
import DowntimeBreakdownAnalysisDashboard from './manufacturing/DowntimeBreakdownAnalysisDashboard';
import QualityMetricsDashboard from './manufacturing/QualityMetricsDashboard';
import OEEDashboard from './manufacturing/OEEDashboard';
import LineLevelPerformanceDashboard from './manufacturing/LineLevelPerformanceDashboard';
import ProcessParametersToolingDashboard from './manufacturing/ProcessParametersToolingDashboard';
import ScrapCostAnalysisDashboard from './manufacturing/ScrapCostAnalysisDashboard';
import EnergyConsumptionDashboard from './manufacturing/EnergyConsumptionDashboard';
import CertificationComplianceDashboard from './audits/CertificationComplianceDashboard';
import NCRTrackerDashboard from './audits/NCRTrackerDashboard';
import CAPADashboard from './audits/CAPADashboard';
import SafetyIncidentsDashboard from './audits/SafetyIncidentsDashboard';
import EnvironmentalComplianceDashboard from './audits/EnvironmentalComplianceDashboard';
import DocumentationStatusDashboard from './audits/DocumentationStatusDashboard';
import FormulasUsedPage from '../documentation/FormulasUsedPage';
import DataModelPage from '../documentation/DataModelPage';
import RisksOpportunitiesDashboard from './executive/RisksOpportunitiesDashboard';
import LeadershipKPIsDashboard from './executive/LeadershipKPIsDashboard';
import PlantBenchmarkingDashboard from './executive/PlantBenchmarkingDashboard';
interface ContentGridProps {
  activeSection: string;
  filters: any;
  selectedItem: {
    type: string | null;
    value: string | null;
  };
  onItemSelect: (type: string, value: string) => void;
  onDrilldown: (type: string, data: any) => void;
}
const ContentGrid: React.FC<ContentGridProps> = ({
  activeSection,
  filters,
  selectedItem,
  onItemSelect,
  onDrilldown
}) => {
  // Documentation Pages
  if (activeSection === 'Formulas Used') {
    return <FormulasUsedPage data-id="element-2660" />;
  }
  if (activeSection === 'View Data Model') {
    return <DataModelPage data-id="element-2661" />;
  }
  // Executive Summary Pages
  if (activeSection === 'Overview') {
    return <ExecutiveSummaryDashboard filters={filters} selectedItem={selectedItem} onItemSelect={onItemSelect} onDrilldown={onDrilldown} data-id="element-2662" />;
  }
  if (activeSection === 'Risks & Opportunities') {
    return <RisksOpportunitiesDashboard data-id="element-2663" />;
  }
  if (activeSection === 'Leadership KPIs') {
    return <LeadershipKPIsDashboard data-id="element-2664" />;
  }
  if (activeSection === 'Plant Benchmarking') {
    return <PlantBenchmarkingDashboard data-id="element-2665" />;
  }
  // Sales Pages
  if (activeSection === 'Sales Overview') {
    return <SalesDashboard filters={filters} selectedItem={selectedItem} onItemSelect={onItemSelect} onDrilldown={onDrilldown} data-id="element-2666" />;
  }
  if (activeSection === 'OEM Sales') {
    return <OEMSalesDashboard data-id="element-2667" />;
  }
  if (activeSection === 'Aftermarket Sales') {
    return <AftermarketSalesDashboard data-id="element-2668" />;
  }
  if (activeSection === 'Product Line Performance') {
    return <ProductLinePerformanceDashboard data-id="element-2669" />;
  }
  if (activeSection === 'Regional Sales') {
    return <RegionalSalesDashboard data-id="element-2670" />;
  }
  if (activeSection === 'Customer Profitability') {
    return <CustomerProfitabilityDashboard data-id="element-2671" />;
  }
  if (activeSection === 'Sales Forecasting') {
    return <SalesForecastingDashboard data-id="element-2672" />;
  }
  if (activeSection === 'Order Book vs Deliveries') {
    return <OrderBookVsDeliveriesDashboard data-id="element-2673" />;
  }
  if (activeSection === 'New Business Pipeline') {
    return <NewBusinessPipelineDashboard data-id="element-2674" />;
  }
  // Marketing Pages
  if (activeSection === 'Marketing Overview') {
    return <MarketingDashboard filters={filters} selectedItem={selectedItem} onItemSelect={onItemSelect} onDrilldown={onDrilldown} data-id="element-2675" />;
  }
  if (activeSection === 'Campaign Performance') {
    return <CampaignPerformanceDashboard data-id="element-2676" />;
  }
  if (activeSection === 'Digital Analytics') {
    return <DigitalAnalyticsDashboard data-id="element-2677" />;
  }
  if (activeSection === 'Product Launch Tracker') {
    return <ProductLaunchTrackerDashboard data-id="element-2678" />;
  }
  if (activeSection === 'Dealer Performance') {
    return <DealerPerformanceDashboard data-id="element-2679" />;
  }
  if (activeSection === 'Market Share Analysis') {
    return <MarketShareAnalysisDashboard data-id="element-2680" />;
  }
  if (activeSection === 'Channel ROI Analysis') {
    return <ChannelROIAnalysisDashboard data-id="element-2681" />;
  }
  // After-Sales Pages
  if (activeSection === 'Service Overview') {
    return <AfterSalesDashboard filters={filters} selectedItem={selectedItem} onItemSelect={onItemSelect} onDrilldown={onDrilldown} data-id="element-2682" />;
  }
  if (activeSection === 'Warranty Claims') {
    return <WarrantyClaimsDashboard data-id="element-2683" />;
  }
  if (activeSection === 'AMC Contracts') {
    return <AMCContractsDashboard data-id="element-2684" />;
  }
  if (activeSection === 'Spare Parts Inventory') {
    return <SparePartsInventoryDashboard data-id="element-2685" />;
  }
  if (activeSection === 'Technician Performance') {
    return <TechnicianPerformanceDashboard data-id="element-2686" />;
  }
  if (activeSection === 'Predictive Maintenance') {
    return <PredictiveMaintenanceDashboard data-id="element-2687" />;
  }
  if (activeSection === 'Root Cause Analysis') {
    return <RootCauseAnalysisDashboard data-id="element-2688" />;
  }
  // Finance Pages
  if (activeSection === 'Financial Overview') {
    return <FinanceDashboard filters={filters} selectedItem={selectedItem} onItemSelect={onItemSelect} onDrilldown={onDrilldown} data-id="element-2689" />;
  }
  if (activeSection === 'P&L by Business Line') {
    return <PLByBusinessLineDashboard data-id="element-2690" />;
  }
  if (activeSection === 'Cost Analytics') {
    return <CostAnalyticsDashboard data-id="element-2691" />;
  }
  if (activeSection === 'Working Capital') {
    return <WorkingCapitalDashboard data-id="element-2692" />;
  }
  if (activeSection === 'Capex Tracking') {
    return <CapexTrackingDashboard data-id="element-2693" />;
  }
  if (activeSection === 'Plant Cost Comparison') {
    return <PlantCostComparisonDashboard data-id="element-2694" />;
  }
  if (activeSection === 'Scenario Modelling') {
    return <ScenarioModellingDashboard data-id="element-2695" />;
  }
  // Supply Chain Pages
  if (activeSection === 'Supply Chain Overview') {
    return <SupplyChainOverviewDashboard data-id="element-2696" />;
  }
  if (activeSection === 'Vendor Performance') {
    return <VendorPerformanceDashboard data-id="element-2697" />;
  }
  if (activeSection === 'Procurement Cost Trends') {
    return <ProcurementCostTrendsDashboard data-id="element-2698" />;
  }
  if (activeSection === 'Lead Time & Logistics') {
    return <LeadTimeLogisticsDashboard data-id="element-2699" />;
  }
  if (activeSection === 'Material Risk Alerts') {
    return <MaterialRiskAlertsDashboard data-id="element-2700" />;
  }
  if (activeSection === 'Import/Export Tracker') {
    return <ImportExportTrackerDashboard data-id="element-2701" />;
  }
  // Operations Pages
  if (activeSection === 'Plant Overview') {
    return <PlaceholderPage title="Plant Overview" section="Operations" data-id="element-2702" />;
  }
  if (activeSection === 'Downtime Analysis') {
    return <PlaceholderPage title="Downtime Analysis" section="Operations" data-id="element-2703" />;
  }
  if (activeSection === 'OEE Dashboards') {
    return <PlaceholderPage title="OEE Dashboards" section="Operations" data-id="element-2704" />;
  }
  if (activeSection === 'Energy Consumption') {
    return <PlaceholderPage title="Energy Consumption & Cost" section="Operations" data-id="element-2705" />;
  }
  // Manufacturing Section
  if (activeSection === 'Production Output') {
    return <ProductionOutputDashboard data-id="element-2706" />;
  }
  if (activeSection === 'Line-Level Performance') {
    return <LineLevelPerformanceDashboard data-id="element-2707" />;
  }
  // Manufacturing Pages
  if (activeSection === 'Manufacturing Overview') {
    return <ManufacturingOverviewDashboard data-id="element-2708" />;
  }
  if (activeSection === 'Capacity Utilization') {
    return <CapacityUtilizationDashboard data-id="element-2709" />;
  }
  if (activeSection === 'Downtime & Breakdown Analysis') {
    return <DowntimeBreakdownAnalysisDashboard data-id="element-2710" />;
  }
  if (activeSection === 'Quality Metrics') {
    return <QualityMetricsDashboard data-id="element-2711" />;
  }
  if (activeSection === 'OEE') {
    return <OEEDashboard data-id="element-2712" />;
  }
  if (activeSection === 'Process Parameters & Tooling') {
    return <ProcessParametersToolingDashboard data-id="element-2713" />;
  }
  if (activeSection === 'Scrap Cost Analysis') {
    return <ScrapCostAnalysisDashboard data-id="element-2714" />;
  }
  if (activeSection === 'Energy Consumption & Cost') {
    return <EnergyConsumptionDashboard data-id="element-2715" />;
  }
  // Audits & Compliance Pages
  if (activeSection === 'Audit Overview') {
    return <AuditOverviewDashboard data-id="element-2716" />;
  }
  if (activeSection === 'Internal Audits') {
    return <InternalAuditsDashboard data-id="element-2717" />;
  }
  if (activeSection === 'External OEM Audits') {
    return <ExternalOEMAuditsDashboard data-id="element-2718" />;
  }
  if (activeSection === 'Certification Compliance') {
    return <CertificationComplianceDashboard data-id="element-2719" />;
  }
  if (activeSection === 'NCR Tracker') {
    return <NCRTrackerDashboard data-id="element-2720" />;
  }
  if (activeSection === 'CAPA') {
    return <CAPADashboard data-id="element-2721" />;
  }
  if (activeSection === 'Safety Incidents') {
    return <SafetyIncidentsDashboard data-id="element-2722" />;
  }
  if (activeSection === 'Environmental Compliance') {
    return <EnvironmentalComplianceDashboard data-id="element-2723" />;
  }
  if (activeSection === 'Documentation Status') {
    return <DocumentationStatusDashboard data-id="element-2724" />;
  }
  // Settings
  if (activeSection === 'Settings') {
    return <PlaceholderPage title="Settings" section="System" data-id="element-2725" />;
  }
  // Default fallback
  return <PlaceholderPage title={activeSection} section="Dashboard" data-id="element-2726" />;
};
export default ContentGrid;